export default __webpack_public_path__ + "static/media/Untitled-1-03.1f1f068b.jpg";